import React, { useEffect, useState } from "react";
import axios from "axios";
import { getCookie } from "../../Utils/cookies";
import { showData } from "../../Utils/APIs/commonShowAPI";
import TableHeading from "../../Components/common/table/Tableheading";
import NormalInputFile from "../../Components/common/input/NormalInputFile";
import NormalButton from "../../Components/common/button/NormalButton";
import installerBulkPay from "../../Assets/Excel/installerBulkPay.xlsx";
import { BsX, BsCheck } from "react-icons/bs";
import { handleFileRead } from "../../Utils/extractExcelData";
const PaymentRequest = () => {
  const empData = getCookie("empData") ? JSON.parse(getCookie("empData")) : "";
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [formData, setFormData] = useState({
    amount: "",
    saralId: "",
    installerId: "",
  });

  const [installerList, setInstallerList] = useState([]);
  const [paymentRequestList, setPaymentRequestList] = useState([]);
  const [reloadPaymentList, setReloadPaymentList] = useState(false);
  const handleChangeInput = (e) => {
    console.log("working...");
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const fetchInstallerList = async () => {
    await showData("installer/getInstallerList", setInstallerList);
  };
  useEffect(() => {
    fetchInstallerList();
  }, []);
  const handleSubmit = async (e) => {
    setBtnDisabled(true);
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/installer/paymentRequestByInstaller`,
        formData,
      );
      //   console.log(response);
      if (response.success === true) {
        setBtnDisabled(false);
        alert(response.data.message);
        setFormData({
          amount: "",
          saralId: "",
          installerId: "",
        });
        setReloadPaymentList(!reloadPaymentList);
      } else {
        setBtnDisabled(false);
        alert(response?.data?.message || "Something went wrong.");
      }
    } catch (error) {
      setBtnDisabled(false);
      console.log("Error : ", error);
      alert(error.response.data?.message || "Something is wrong");
    }
  };
  const fetchPaymentRequestList = async () => {
    try {
      await showData(
        "installer/getPaymentRequestByInstaller",
        setPaymentRequestList,
      );
    } catch (error) {
      alert("something is wrong please try again to fetch payment list");
    }
  };
  useEffect(() => {
    fetchPaymentRequestList();
  }, [reloadPaymentList]);

  const headingList = [
    "",
    "sr.no.",
    "saral-id",
    "farmer name",
    "state",
    "installation date",
    "employee name",
    "installer name",
    "amount",
    "Approved",
    "reject",
  ];
  const updatePayment = async (_id, status) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/installer/updateInstallerData`,
        { _id, status },
      );
      console.log(response);
      if (response.data.success === true) {
        alert(response.data.message);
        setReloadPaymentList((prev) => !prev);
      } else {
        alert(response?.data?.message || "Something went wrong.");
      }
    } catch (error) {
      console.log("Error : ", error);
      alert(error.response.data?.message || "Something is wrong");
    }
  };
  // ADD THESE STATES
  const [selectedIds, setSelectedIds] = useState([]);
  const allSelected = selectedIds.length === paymentRequestList.length;

  // HANDLE SINGLE CHECKBOX
  const handleSelect = (_id) => {
    console.log("Selected ID:", _id);
    if (selectedIds.includes(_id)) {
      setSelectedIds(selectedIds.filter((x) => x !== _id));
    } else {
      setSelectedIds([...selectedIds, _id]);
    }
  };
  useEffect(() => {
    console.log("Selected IDs:", selectedIds);
  }, [selectedIds]);
  // HANDLE SELECT ALL
  const handleSelectAll = () => {
    if (allSelected) {
      setSelectedIds([]);
    } else {
      setSelectedIds(paymentRequestList.map((item) => item._id));
    }
  };

  const multipleUpdatePayment = async (status) => {
    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/installer/updateManyInstallerData`,
      { _id: selectedIds, status },
    );
    if (response.data.success === true) {
      setPaymentRequestList((prev) =>
        prev.filter((item) => !selectedIds.includes(item._id)),
      );
      setSelectedIds([]);
    } else {
      alert(response?.data?.message || "Something went wrong.");
    }
  };
  const [bulkUploadExcel, setBulkUploadExcel] = useState("");
  const uploadExcelForBulkPay = async () => {
    try {
      if (!bulkUploadExcel) {
        alert("Please select Excel");
        return;
      }

      const formData = new FormData();
      formData.append("file", bulkUploadExcel);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/installer/bulkPaymentRequestByInstaller`,
        formData,
        {
          responseType: "arraybuffer", // 🔥 KEY CHANGE
          headers: {
            Accept:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
        },
      );

      const contentType = response.headers["content-type"] || "";

      // ✅ Excel response
      if (contentType.includes("spreadsheetml")) {
        const blob = new Blob([response.data], {
          type: contentType,
        });

        const url = window.URL.createObjectURL(blob);

        let fileName = "Report.xlsx";
        const disposition = response.headers["content-disposition"];
        if (disposition) {
          const match = disposition.match(
            /filename\*?=(?:UTF-8'')?["']?([^;"']+)/i,
          );
          if (match?.[1]) {
            fileName = decodeURIComponent(match[1].replace(/"/g, ""));
          }
        }

        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();

        a.remove();
        window.URL.revokeObjectURL(url);
        return;
      }

      // ✅ CASE 2: JSON response (success message)
      const jsonData = response?.data;
      if (jsonData.success) {
        alert(jsonData.message);
      } else {
        alert("Something went wrong");
      }
    } catch (error) {
      console.error("Excel upload error:", error);
      alert(
        error?.response?.data?.message ||
          "Something went wrong while uploading Excel",
      );
    }
  };

  // saral id file upload and select matches saral id in payment request list and show matched data in alert box
  const [saralIdExcel, setSaralIdExcel] = useState(null);
  useEffect(() => {
    async function fetchDataForSaralIdExcel(saralIdExcel) {
      if (!saralIdExcel) return;
      const jsonData = await handleFileRead(saralIdExcel);
      console.log("jsonData =>", jsonData);
      const totalSize = jsonData.length;
      const matchedIdsSet = new Set();
      jsonData?.forEach((row) => {
      const saralId = row?.[0]?.trim();

      const matchedRequests = paymentRequestList?.filter(
        (request) =>
          request.FarmerData?.[0]?.saralId?.trim() === saralId
      );

      matchedRequests?.forEach((req) => {
        matchedIdsSet.add(req._id);
      });
    });
    setSelectedIds([...matchedIdsSet]);
    setSaralIdExcel(null);  
    alert(`Total Saral IDs in Excel: ${totalSize}\nMatched Payment Requests: ${matchedIdsSet.size}`);

    }
    fetchDataForSaralIdExcel(saralIdExcel);
  }, [saralIdExcel]);
  return (
    <div className="w-full h-full flex flex-col">
      {["Service", "Transport"].includes(empData.role) && (
        <>
          <div className="mainHeading">
            <h1 className="text-3xl font-semibold tracking-widest text-center p-2 bg-gray-50  rounded-lg">
              P<span className="text-lg">AYMENT</span> R
              <span className="text-lg">EQUEST</span>
            </h1>
          </div>
          <div className="w-full">
            <div className="formField">
              <form onSubmit={handleSubmit}>
                <div className="grid gap-3 m-6 md:grid-cols-4">
                  <div>
                    <label
                      htmlFor="amount"
                      className="block mb-2 text-sm font-medium text-gray-900 "
                    >
                      Amount<span className="text-red-500 fixed h-3">*</span>
                    </label>
                    <input
                      type="number"
                      id="amount"
                      name="amount"
                      min={0}
                      onChange={handleChangeInput}
                      value={formData?.amount}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5 "
                      placeholder="Enter Amount"
                      required
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="name"
                      className="block mb-2 text-sm font-medium text-gray-900 "
                    >
                      Farmer Saral-Id
                      <span className="text-red-500 fixed h-3">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="saralId"
                      onChange={handleChangeInput}
                      value={formData?.saralId}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5 "
                      placeholder="Enter Farmer saral-Id"
                      required
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="state"
                      className="block mb-2 text-sm font-medium text-gray-900 "
                    >
                      Select Installer
                      <span className="text-red-500 fixed h-3">*</span>
                    </label>
                    <select
                      name="installerId"
                      onChange={handleChangeInput}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    >
                      {formData?.installerId === "" ? (
                        <option>Select Installer</option>
                      ) : (
                        <option disabled>Select State</option>
                      )}
                      {installerList?.map(({ name, _id }, index) => (
                        <option key={index} value={_id}>
                          {name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div
                    style={{
                      display: "block",
                      flexDirection: "column",
                      alignItems: "center",
                      alignContent: "center",
                      height: 96,
                    }}
                  >
                    <button
                      type="submit"
                      className="text-dark bg-yellow-500 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full px-5 py-2.5 text-center sm:w-full"
                      disabled={btnDisabled}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="mainHeading">
            <h1 className="text-3xl font-semibold tracking-widest text-center p-2 bg-gray-50  rounded-lg">
              B<span className="text-lg">ULK </span>P
              <span className="text-lg">AYMENT </span>R
              <span className="text-lg">EQUEST</span>
            </h1>

            <div className="grid gap-3 m-6 md:grid-cols-2">
              <div>
                <NormalInputFile
                  isRequired={true}
                  label="Excel Upload"
                  placeholder={null}
                  setterFun={setBulkUploadExcel}
                  type="file"
                />
                <a
                  href={installerBulkPay}
                  download="InstallerPaymentFormat.xlsx"
                  className="text-sm text-blue-600"
                >
                  Download Format
                </a>
              </div>
              <NormalButton
                btnName="Upload"
                onClickFun={uploadExcelForBulkPay}
                cssClass="bg-yellow-500 rounded-sm h-12 font-semibold mt-7"
              />
            </div>
          </div>
        </>
      )}
      <div className="w-full h-full overflow-auto">
        {(empData.role === "Admin" || empData.role === "Super Admin" || empData.role === "Installation") &&
          (empData.department === "payment-verify" ||
            empData.department === "Department Head" || empData.department ==="Filing Head") && (
            <>
              <div className="mainHeading">
                <h1 className="text-3xl font-semibold tracking-widest text-center p-2 bg-gray-50  rounded-lg">
                  P<span className="text-lg">AYMENT</span> R
                  <span className="text-lg">EQUEST</span> L
                  <span className="text-lg">IST</span>
                </h1>
              </div>
              <div className="bg-white relative flex items-center justify-end py-1 px-2">
                {selectedIds.length > 0 && (
                  <span className="mr-auto text-sm font-medium">
                    Total Saral Ids selected : {selectedIds.length} 
                  </span>
                )}
                <div>
                  <NormalInputFile
                    setterFun={setSaralIdExcel}
                    isRequired={false}
                    type="file"
                    value={null}
                  />
                </div>
                {selectedIds.length > 0 && (
                  <div className="flex gap-2 pl-2">
                    <button
                      className="font-medium rounded-sm text-sm w-full sm:w-auto px-2 py-1 text-center bg-green-500 hover:bg-green-600 text-white"
                      onClick={(e) => multipleUpdatePayment("Approved")}
                    >
                      <BsCheck className="inline size-6" />
                    </button>
                    <button
                      className="font-medium rounded-sm text-sm w-full sm:w-auto px-2 py-1 text-center bg-red-500 hover:bg-red-600 text-white"
                      onClick={(e) => multipleUpdatePayment("Reject")}
                    >
                      <BsX className="inline size-6" />
                    </button>
                  </div>
                )}
              </div>
              <table className="table w-full relative justify-center text-center border">
                <TableHeading list={headingList} />
                <input
                  type="checkbox"
                  className="absolute top-3 left-6 z-30 w-4 h-4"
                  checked={allSelected}
                  onChange={handleSelectAll}
                />
                <tbody>
                  {paymentRequestList.length > 0 &&
                    paymentRequestList.map((item, index) => (
                      <tr className="hover:bg-slate-100">
                        <td className="px-4 py-2 whitespace-nowrap">
                          <input
                            type="checkbox"
                            className="w-4 h-4"
                            value={item._id}
                            checked={selectedIds.includes(item._id)}
                            onChange={() => handleSelect(item._id)}
                          />
                        </td>
                        <td className="px-2 py-1 text-sm whitespace-nowrap">
                          {++index}
                        </td>
                        <td className="px-2 py-1 text-sm whitespace-nowrap">
                          {item.FarmerData?.[0]?.saralId}
                        </td>
                        <td className="px-2 py-1 text-sm whitespace-nowrap">
                          {item.FarmerData?.[0]?.farmerName}
                        </td>
                        <td className="px-2 py-1 text-sm whitespace-nowrap">
                          {item.FarmerData?.[0]?.state}
                        </td>
                        <td className="px-2 py-1 text-sm whitespace-nowrap">
                          {item.FarmerData?.[0]?.installationDate
                            ? (() => {
                                const d = new Date(
                                  item.FarmerData[0].installationDate,
                                );
                                return `${d.getDate()}-${
                                  d.getMonth() + 1
                                }-${d.getFullYear()}`;
                              })()
                            : ""}
                        </td>
                        <td className="px-2 py-1 text-sm whitespace-nowrap">
                          {item.Employee?.[0]?.name}
                        </td>
                        <td className="px-2 py-1 text-sm whitespace-nowrap">
                          {item.Installer?.[0]?.name}
                        </td>
                        <td className="px-2 py-1 text-sm whitespace-nowrap">
                          {item.amount}
                        </td>
                        <td className="px-2 py-1 text-sm whitespace-nowrap">
                          <button
                            className="font-medium rounded-sm text-sm w-full sm:w-auto px-2 py-1 text-center bg-green-500 hover:bg-green-600 text-white"
                            onClick={(e) => updatePayment(item._id, "Approved")}
                          >
                            <BsCheck className="inline size-6" />
                          </button>
                        </td>
                        <td className="px-2 py-1 text-sm">
                          <button
                            className="font-medium rounded-sm text-sm w-full sm:w-auto px-2 py-1 text-center bg-red-500 hover:bg-red-600 text-white"
                            onClick={(e) => updatePayment(item._id, "Reject")}
                          >
                            <BsX className="inline size-6" />
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </>
          )}
      </div>
    </div>
  );
};

export default PaymentRequest;
